import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWorkStatusList as getWorkStatusListApi,
	getWorkStatusListQuery as getWorkStatusListQueryApi,
	getWorkStatus as getWorkStatusApi,
	addNewWorkStatusApi,
	updateWorkStatusApi,
	deleteWorkStatusApi,
	checkWorkStatusExistsApi,
} from '../../helpers/work_status/api_helper';

export const getWorkStatusList = createAsyncThunk(
	'workStatus/getWorkStatusList',
	async () => {
		try {
			const response = await getWorkStatusListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los estados de actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWorkStatusListQuery = createAsyncThunk(
	'workStatus/getWorkStatusListQuery',
	async params => {
		try {
			const response = getWorkStatusListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWorkStatus = createAsyncThunk(
	'workStatus/getWorkStatus',
	async work_status_id => {
		try {
			const response = await getWorkStatusApi(work_status_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el estado de actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWorkStatus = createAsyncThunk(
	'workStatus/addNewWorkStatus',
	async work_status => {
		try {
			const response = await addNewWorkStatusApi(work_status);
			toast.success('Estado de Actividad agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el estado de actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWorkStatus = createAsyncThunk(
	'workStatus/updateWorkStatus',
	async work_status => {
		try {
			const response = await updateWorkStatusApi(work_status);
			toast.success('Estado de Actividad actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el estado de actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWorkStatus = createAsyncThunk(
	'workStatus/deleteWorkStatus',
	async work_status => {
		try {
			const response = await deleteWorkStatusApi(work_status._id);
			toast.success('Estado de Actividad eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return work_status;
		} catch (error) {
			toast.error('Error al eliminar el estado de actividad.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWorkStatusExists = createAsyncThunk(
	'workStatus/checkWorkStatusExists',
	async name => {
		try {
			const response = await checkWorkStatusExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
